/** Moving one item in a list, the step every drop of the kit's SortableList ends with (one management screen, 2026-10-12). The form embed
 *  round (2026-10-26): the keyboard's state machine and the edge scrolling are dnd-kit's now, where a row lands is `sortableLanding.ts`. */

/** a new array with the item at `from` moved to `to` (indexes into the list, `to` clamped into it); the input is left as it was */
export function reorder<T>(list: T[], from: number, to: number): T[] {
  if (from < 0 || from >= list.length) return [...list];
  const target = Math.max(0, Math.min(list.length - 1, to));
  const out = [...list];
  const [item] = out.splice(from, 1);
  out.splice(target, 0, item!);
  return out;
}
